
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[page]",
      function () {
        return require("private-next-pages/blog/[page].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/[page]"])
      });
    }
  